module.exports = __webpack_public_path__ + "img/thumb_Atelier_4.0708c55f.jpg";